import lowerCase from 'lodash-es/lowerCase';
import lowerFirst from 'lodash-es/lowerFirst';
import upperFirst from 'lodash-es/upperFirst';

export function fixNumber(
  number: number,
  fractionSymbols: 'auto' | number = 2,
) {
  const value = Number(number);

  return fractionSymbols === 'auto'
    ? String(value)
    : value.toFixed(fractionSymbols);
}
function formatKNotation(number: number | string, precision: number) {
  const sanitizedNumber = Number(String(number).replace(/[^0-9.]/g, ''));

  if (sanitizedNumber < 1000) {
    return sanitizedNumber;
  }
  const si = [
    { v: 1e3, s: 'K' },
    { v: 1e6, s: 'M' },
    { v: 1e9, s: 'B' },
    { v: 1e12, s: 'T' },
    { v: 1e15, s: 'P' },
    { v: 1e18, s: 'E' },
  ];
  let index;

  for (index = si.length - 1; index > 0; index--) {
    if (sanitizedNumber >= si[index].v) {
      break;
    }
  }

  return (
    (sanitizedNumber / si[index].v)
      .toFixed(precision)
      .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[index].s
  );
}

export function humanizeNumber(
  number: number,
  precision: 'auto' | number = 0,
  kNotation: boolean = false,
) {
  return kNotation
    ? formatKNotation(number, precision === 'auto' ? 0 : precision)
    : fixNumber(number, precision).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function humanizePercents(
  amount: number,
  fraction: number = 0,
  kNotation: boolean = false,
) {
  return humanizeNumber(amount, fraction, kNotation);
}

export function humanizeMoney(
  amount: number,
  precision: 'auto' | number,
  kNotation: boolean = false,
  currency = '',
) {
  return `${Number(amount) < 0 ? '-' : ''}${currency}${humanizeNumber(
    Math.abs(amount),
    precision,
    kNotation,
  )}`;
}

export function humanizeCamelCase(string: string) {
  return upperFirst(lowerCase(string));
}

export const unhumanizeToCamelCase = (string = '') =>
  lowerFirst(string.split(/\s+/g).map(upperFirst).join(''));
